module.exports = __webpack_public_path__ + "img/Screenshot_1.cf87e775.png";